module.exports = __webpack_public_path__ + "img/norway-external-causes-female.300a29c8.png";